
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Loading from "../../../components/common/Loading";
import { Oval } from "react-loader-spinner";

const TermsofService = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => setLoading(false), 1500);
  }, []);


  const termsSections = [
    {
      title: "Terms of Use – IHFC Technology Innovation Hub, IIT Delhi",
      content:
        "These Terms of Use govern your access to and use of the IHFC (I-Hub Foundation for Cobotics) Technology Innovation Hub platform at IIT Delhi. By accessing or using our platform, you agree to comply with these terms and to use the services in accordance with all applicable laws and regulations.",
    },
    {
      title: "User Responsibilities",
      content:
        "You are responsible for maintaining the confidentiality of your login credentials and for all activities conducted under your account. You agree to use the IHFC platform solely for purposes including research, innovation, technology collaboration, incubation programs, events, and accessing educational or industry-related resources provided by IHFC.",
    },
    {
      title: "Prohibited Activities",
      content: "You agree not to:",
      lists: [
        "Attempt unauthorized access to the platform, systems, or associated data",
        "Share false, harmful, offensive, or misleading content",
        "Interfere with the functionality, security, or availability of the platform",
        "Exploit, misuse, or reverse engineer platform features in violation of these terms",
        "Use the platform for commercial activities not authorized by IHFC"
      ]
    },
    {
      title: "Intellectual Property",
      content:
        "All content made available through IHFC, including but not limited to research publications, reports, training materials, visuals, platform design, and digital resources, is the intellectual property of IHFC, IIT Delhi, or its partners. You may not reproduce, distribute, or repurpose any content without prior written consent from IHFC.",
    },
    {
      title: "Account Suspension or Termination",
      content: "IHFC reserves the right to suspend or permanently terminate your access if:",
      lists: [
        "You violate any of these Terms of Use",
        "Your actions pose a risk to the security or operations of the platform",
        "You misuse the platform in a way deemed harmful, unethical, or unlawful"
      ]
    },
    {
      title: "Changes to Terms",
      content:
        "IHFC may update these Terms of Use from time to time. Any material changes will be communicated via email or platform notifications. Continued use of the platform after such updates will constitute your acceptance of the revised terms.",
    },
  ];

  return (
    <div className="content-inner">
      <Container fluid className="container">
        {loading
          ? <>
            <div
              className="d-flex justify-content-center "
              style={{ height: "85vh", paddingTop: "15vh" }}
            >
              <Oval
                height="50"
                width="50"
                color="#4fa94d"
                secondaryColor="#4fa94d"
              />
            </div>
          </>
          : (
            <>
              <Row>
                <Col lg="12" className="mb-4">
                  <div className="bg-primary text-white text-center py-4 rounded shadow">
                    <h2
                      className="mb-0 text-white  "
                      style={{ textTransform: "none" }}
                    >
                      Terms of Use
                    </h2>
                    <p className="mb-0 px-2 mt-2" style={{ lineHeight: "1.4" }}>
                      Please read our terms carefully before using our services.
                    </p>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg="12">
                  {termsSections.map((section, index) => {
                    return (
                      <Card key={index} className="p-3 p-md-0">
                        <Card.Header className="d-flex justify-content-between pb-0">
                          <div className="header-title">
                            <h4
                              className="card-title"
                              style={{ textTransform: "none" }}
                            >
                              {section?.title}
                            </h4>
                          </div>
                        </Card.Header>
                        <Card.Body className="py-2">
                          <p>{section?.content}</p>
                          {section?.lists && (
                            <ul className="pt-0 px-">
                              {section?.lists?.map((item) => <li>{item}</li>)}
                            </ul>
                          )}
                        </Card.Body>
                      </Card>
                    );
                  })}
                </Col>
                ;
              </Row>
            </>)}
      </Container>
    </div>
  );
};

export default TermsofService;

// import React from "react";
// import { Container, Row, Col, Card } from "react-bootstrap";

// const TermsofService = () => {
//   const termsSections = [
//     {
//       title: "Terms of Use",
//       content:
//         "These Terms of Use govern your access to and use of our participant application. By using the platform, you agree to comply with these terms and use the services in accordance with applicable laws and regulations.",
//     },
//     {
//       title: "User Responsibilities",
//       content:
//         "You are responsible for keeping your login credentials secure and for all actions taken under your account. You agree to use the application solely for participating in courses, viewing content, and communicating with authorized personnel.",
//     },
//     {
//       title: "Prohibited Activities",
//       content:
//         "You must not engage in any activity that disrupts or attempts to compromise the platform, including but not limited to unauthorized access, distribution of harmful content, misuse of data, or interfering with other users’ experiences.",
//     },
//     {
//       title: "Intellectual Property",
//       content:
//         "All course materials, documents, interface elements, and related content available in the application are owned by the platform or its licensors. You may not copy, distribute, or reuse this content without prior written permission.",
//     },
//     {
//       title: "Termination",
//       content:
//         "We reserve the right to suspend or terminate your access to the application at any time if you violate these Terms of Use or engage in any activity that threatens the security or integrity of the platform.",
//     },
//     {
//       title: "Changes to Terms",
//       content:
//         "These terms may be updated periodically. Your continued use of the application after any changes have been made constitutes acceptance of those updated terms.",
//     },
//   ];

//   return (
//     <div className="content-inner">
//       <Container fluid className="container">
//         <Row>
//           <Col lg="12" className="mb-4">
//             <div className="bg-primary text-white text-center py-4 rounded shadow">
//               <h2
//                 className="mb-0 text-white  "
//                 style={{ textTransform: "none" }}
//               >
//                 Terms of Use
//               </h2>
//               <p className="mb-0 px-2 mt-2" style={{ lineHeight: "1.4" }}>
//                 Please read our terms carefully before using our services.
//               </p>
//             </div>
//           </Col>
//         </Row>

//         <Row>
//           <Col lg="12">
//             {termsSections.map((item, index) => {
//               return (
//                 <Card key={index} className="p-3 p-md-0">
//                   <Card.Header className="d-flex justify-content-between pb-0">
//                     <div className="header-title">
//                       <h4
//                         className="card-title"
//                         style={{ textTransform: "none" }}
//                       >
//                         {item?.title}
//                       </h4>
//                     </div>
//                   </Card.Header>
//                   <Card.Body className="py-2">
//                     <p>{item?.content}</p>
//                   </Card.Body>
//                 </Card>
//               );
//             })}
//           </Col>
//           ;
//         </Row>
//       </Container>
//     </div>
//   );
// };

// export default TermsofService;

// // import React from "react";
// // import { Container, Row, Col, Card } from "react-bootstrap";

// // const TermsofService = () => {
// //   return (
// //     <div className="content-inner">
// //       <Container>
// //         <Row>
// //           <Col lg="12">
// //             <div className="iq-accordion career-style faq-style  ">
// //               <Card className="iq-accordion-block accordion-active p-0">
// //                 <Card.Header className="active-faq clearfix d-flex justify-content-between pb-0">
// //                   <div className="header-title">
// //                     <h4 className="card-title">Lorem ipsum dolor sit</h4>
// //                   </div>
// //                 </Card.Header>
// //                 <Card.Body className="accordion-details">
// //                   <p className="mb-0 p-0">
// //                     Anim pariatur cliche reprehenderit, enim eiusmod high life
// //                     accusamus terry richardson ad squid. 3 wolf moon officia
// //                     aute, non cupidatat skateboard dolor brunch. Food truck
// //                     quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
// //                     sunt aliqua put a bird on it squid single-origin coffee
// //                     nulla assumenda shoreditch et. Nihil anim keffiyeh
// //                     helvetica, craft beer labore wes anderson cred nesciunt
// //                     sapiente ea proident. Ad vegan excepteur butcher vice lomo.
// //                     Leggings occaecat craft beer farm-to-table, raw denim
// //                     aesthetic synth nesciunt you probably haven't heard of them
// //                     accusamus labore sustainable VHS.{" "}
// //                   </p>
// //                 </Card.Body>
// //               </Card>
// //               <div className="iq-accordion career-style faq-style  ">
// //                 <Card className="iq-accordion-block p-0">
// //                   <Card.Header className="active-faq clearfix d-flex justify-content-between pb-0">
// //                     <div className="header-title">
// //                       <h4 className="card-title">
// //                         consectetur adipiscing elit
// //                       </h4>
// //                     </div>
// //                   </Card.Header>
// //                   <Card.Body className="accordion-details">
// //                     <p className="mb-0 p-0">
// //                       Anim pariatur cliche reprehenderit, enim eiusmod high life
// //                       accusamus terry richardson ad squid. 3 wolf moon officia
// //                       aute, non cupidatat skateboard dolor brunch. Food truck
// //                       quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
// //                       tempor, sunt aliqua put a bird on it squid single-origin
// //                       coffee nulla assumenda shoreditch et. Nihil anim keffiyeh
// //                       helvetica, craft beer labore wes anderson cred nesciunt
// //                       sapiente ea proident. Ad vegan excepteur butcher vice
// //                       lomo. Leggings occaecat craft beer farm-to-table, raw
// //                       denim aesthetic synth nesciunt you probably haven't heard
// //                       of them accusamus labore sustainable VHS.{" "}
// //                     </p>
// //                   </Card.Body>
// //                 </Card>
// //               </div>
// //               <div className="iq-accordion career-style faq-style  ">
// //                 <Card className="card iq-accordion-block p-0">
// //                   <Card.Header className="active-faq clearfix d-flex justify-content-between pb-0">
// //                     <div className="header-title">
// //                       <h4 className="card-title">Etiam sit amet justo non</h4>
// //                     </div>
// //                   </Card.Header>
// //                   <Card.Body className="accordion-details">
// //                     <p className="mb-0 p-0">
// //                       Anim pariatur cliche reprehenderit, enim eiusmod high life
// //                       accusamus terry richardson ad squid. 3 wolf moon officia
// //                       aute, non cupidatat skateboard dolor brunch. Food truck
// //                       quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
// //                       tempor, sunt aliqua put a bird on it squid single-origin
// //                       coffee nulla assumenda shoreditch et. Nihil anim keffiyeh
// //                       helvetica, craft beer labore wes anderson cred nesciunt
// //                       sapiente ea proident. Ad vegan excepteur butcher vice
// //                       lomo. Leggings occaecat craft beer farm-to-table, raw
// //                       denim aesthetic synth nesciunt you probably haven't heard
// //                       of them accusamus labore sustainable VHS.{" "}
// //                     </p>
// //                   </Card.Body>
// //                 </Card>
// //               </div>
// //               <div className="iq-accordion career-style faq-style  ">
// //                 <Card className="iq-accordion-block p-0">
// //                   <Card.Header className="active-faq clearfix d-flex justify-content-between pb-0">
// //                     <div className="header-title">
// //                       <h4 className="card-title">velit accumsan laoreet</h4>
// //                     </div>
// //                   </Card.Header>
// //                   <Card.Body className="accordion-details">
// //                     <p className="mb-0 p-0">
// //                       Anim pariatur cliche reprehenderit, enim eiusmod high life
// //                       accusamus terry richardson ad squid. 3 wolf moon officia
// //                       aute, non cupidatat skateboard dolor brunch. Food truck
// //                       quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
// //                       tempor, sunt aliqua put a bird on it squid single-origin
// //                       coffee nulla assumenda shoreditch et. Nihil anim keffiyeh
// //                       helvetica, craft beer labore wes anderson cred nesciunt
// //                       sapiente ea proident. Ad vegan excepteur butcher vice
// //                       lomo. Leggings occaecat craft beer farm-to-table, raw
// //                       denim aesthetic synth nesciunt you probably haven't heard
// //                       of them accusamus labore sustainable VHS.{" "}
// //                     </p>
// //                   </Card.Body>
// //                 </Card>
// //               </div>
// //               <div className="iq-accordion career-style faq-style">
// //                 <Card className="iq-accordion-block p-0">
// //                   <Card.Header className="active-faq clearfix d-flex justify-content-between pb-0">
// //                     <div className="header-title">
// //                       <h4 className="card-title">
// //                         Donec volutpat metus in erat
// //                       </h4>
// //                     </div>
// //                   </Card.Header>
// //                   <Card.Body className="accordion-details">
// //                     <p className="mb-0 p-0">
// //                       Anim pariatur cliche reprehenderit, enim eiusmod high life
// //                       accusamus terry richardson ad squid. 3 wolf moon officia
// //                       aute, non cupidatat skateboard dolor brunch. Food truck
// //                       quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
// //                       tempor, sunt aliqua put a bird on it squid single-origin
// //                       coffee nulla assumenda shoreditch et. Nihil anim keffiyeh
// //                       helvetica, craft beer labore wes anderson cred nesciunt
// //                       sapiente ea proident. Ad vegan excepteur butcher vice
// //                       lomo. Leggings occaecat craft beer farm-to-table, raw
// //                       denim aesthetic synth nesciunt you probably haven't heard
// //                       of them accusamus labore sustainable VHS.{" "}
// //                     </p>
// //                   </Card.Body>
// //                 </Card>
// //               </div>
// //               <div className="iq-accordion career-style faq-style  ">
// //                 <Card className="card iq-accordion-block p-0">
// //                   <Card.Header className="active-faq clearfix d-flex justify-content-between pb-0">
// //                     <div className="header-title">
// //                       <h4 className="card-title">quam quis massa tristique</h4>
// //                     </div>
// //                   </Card.Header>
// //                   <Card.Body className="accordion-details">
// //                     <p className="mb-0 p-0">
// //                       Anim pariatur cliche reprehenderit, enim eiusmod high life
// //                       accusamus terry richardson ad squid. 3 wolf moon officia
// //                       aute, non cupidatat skateboard dolor brunch. Food truck
// //                       quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
// //                       tempor, sunt aliqua put a bird on it squid single-origin
// //                       coffee nulla assumenda shoreditch et. Nihil anim keffiyeh
// //                       helvetica, craft beer labore wes anderson cred nesciunt
// //                       sapiente ea proident. Ad vegan excepteur butcher vice
// //                       lomo. Leggings occaecat craft beer farm-to-table, raw
// //                       denim aesthetic synth nesciunt you probably haven't heard
// //                       of them accusamus labore sustainable VHS.{" "}
// //                     </p>
// //                   </Card.Body>
// //                 </Card>
// //               </div>
// //             </div>
// //           </Col>
// //         </Row>
// //       </Container>
// //     </div>
// //   );
// // };

// // export default TermsofService;
